// import { getToApi } from 'venuescanner-js/services/api'
import isSSR from "venuescanner-js/services/isSSR";
// import serviceURLs from '../serviceURLs.json'
import Notification from "./notification";
import controllers from "../controllers";

/** @module
 * @name Notifications
 * @desc Service class for fetching the Users notification settings and updating them
 */
const Notifications = {
  versions: {
    standard: {
      controller: controllers.userService.notifications.get,
      // url: serviceURLs.notifications,
      notifications: null,
      inflights: [],
    },
  },
  inflights: [],
  /**
   * @name fetch
   * @param {string} [version=standard]  - Defaults to standard
   * @desc Fetches all accessible Published Venues
   * @returns {Promise<Notification>}
   */
  fetch: async function (version = "standard") {
    if (!this.versions[version])
      throw new Error(`${version} is not an accepted venue version`);
    if (this.versions[version].notifications)
      return this.versions[version].notifications;
    return new Promise((resolve) => {
      this.versions[version].inflights.push(resolve);
      if (this.versions[version].inflights.length === 1) this.load(version);
    });
  },
  /**
   * @name load
   * @param {string} [version=standard]  - Defaults to standard
   * @desc Used by the class to perform the actual api call for the Venues and then resolves all the inflights with instances of the Venues
   * @returns {Promise<Notification>}
   */
  load: function (version = "standard") {
    if (isSSR() || window.isTest) {
      this.versions[version].notifications = {};
      if (!isSSR() && window.isTest) {
        while (this.versions[version].inflights.length) {
          const resolve = this.versions[version].inflights.shift();
          resolve(this.versions[version].notifications);
        }
      }
    } else {
      // getToApi(this.versions[version].url, { returnData: true })
      this.versions[version].controller().then(({ data: notifications }) => {
        this.versions[version].notifications = new Notification(notifications);
        while (this.versions[version].inflights.length) {
          const resolve = this.versions[version].inflights.shift();
          resolve(this.versions[version].notifications);
        }
      });
    }
  },
};
if (typeof window !== "undefined") window.Notifications = Notifications;
export default Notifications;
